import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { ClientRecordAction } from "../../Action/ClientRecordAction";
import { RegulatoryTabs } from "../../Resource/RegulatoryContents";
import { TableViewSection } from "../TableViewSection";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { RoleStatusMap } from "../../Resource/Contents";
import {
    ControllingPersonTypeArray,
    ControllingPersonTypeMap,
} from "../../../PortfolioDashboard/Components/Role/Resource/Contents";
import { ControllingPersonRoleDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/ControllingPersonRoleDetailModel";
import { ControllingPersonType } from "../../../../../../../Wrap/Constants/Enums/Customer/ControllingPersonType";
import { CustomerTaxResidencyModel } from "../../../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { CountryCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { ErrorMessagePopup } from "../../../../../../Shared/Components/ErrorMessagePopup";

interface IControllingPersonDetailsProps {
    customerid: number;
    hasReadWriteAccess: boolean;
    data: Array<ControllingPersonRoleDetailModel>;
    residencyData: Array<CustomerTaxResidencyModel>;
    isLoading: boolean;
    onSave: (data: ControllingPersonRoleDetailModel, selectedType: ControllingPersonType) => boolean;
}
interface IControllingPersonDetailsState {
    selectedType: ControllingPersonType;
}
export class ControllingPersonDetails extends FormComponent<
    IControllingPersonDetailsProps,
    IControllingPersonDetailsState
> {
    constructor(props: IControllingPersonDetailsProps) {
        super(props);
        this.state = {
            selectedType: ControllingPersonType.NotSpecified,
        };
    }

    hasNonUKTaxResidency(): boolean {
        const { residencyData } = this.props;
        return residencyData.filter((x) => x.Country != CountryCode.GBR && x.IsTaxResident).length > 0;
    }

    render() {
        const { data, isLoading } = this.props;
        if (isLoading) {
            return <PartLoading isLoading={true} />;
        }
        if (data == null || data?.length == 0) {
            return null;
        }
        const columnConfigs = [
            {
                title: "Account",
                key: "ClAccountId",
            },
            {
                title: "Legal name/Corporate name",
                key: "AccountName",
            },
            {
                title: "Type of controlling person",
                key: "ControllingPersonType",
                render: (x) => {
                    return ControllingPersonTypeMap[x];
                },
            },
            {
                title: "Status",
                key: "AccountRoleStatus",
                render: (x) => {
                    return RoleStatusMap[x];
                },
            },
            {
                title: "Role start date",
                key: "RoleStartDate",
                render: (x) => {
                    return x == null ? "-" : JsonDateParser.getFormatDate(x, "dd/MM/yyyy");
                },
            },
            {
                title: "Role end date",
                key: "RoleEndDate",
                render: (x) => {
                    return x == null ? "-" : JsonDateParser.getFormatDate(x, "dd/MM/yyyy");
                },
            },
        ];
        return (
            <>
                <TableViewSection
                    sectionHeader={RegulatoryTabs.ControllingPersonDetails}
                    columnConfigs={columnConfigs}
                    lightboxContent={(data, onDataChange) => this.renderLightBox(data, onDataChange)}
                    onSave={(data) => this.isValid() && this.props.onSave(data, this.state.selectedType)}
                    data={data}
                    canAdd={false}
                    canEdit={this.props?.hasReadWriteAccess == true}
                    canRemove={false}
                />
            </>
        );
    }

    renderLightBox(data: ControllingPersonRoleDetailModel, onDataChange): JSX.Element {
        return (
            <>
                <p>{data.ClAccountId}</p>
                <SelectEditor
                    options={ControllingPersonTypeArray}
                    getText={(o) => ControllingPersonTypeMap[o]}
                    placeholder="Please select"
                    label={"Type of Controlling person"}
                    required="Please select a type"
                    selected={data?.ControllingPersonType}
                    cssWrapper="control-size-430"
                    onChange={(v) => {
                        this.onTypeChange(v);
                    }}
                    validationRules={[
                        {
                            errorMessage:
                                "Validation error the controlling person cannot be a blank as tax residence is Non UK",
                            validator: (v) => {
                                // no need check for non not-specifiec value
                                if (v != ControllingPersonType.NotSpecified) {return true;}
                                // if value = not specifiec and has non uk tax residency, validation failed
                                return !this.hasNonUKTaxResidency();
                            },
                        },
                    ]}
                />
            </>
        );
    }
    onTypeChange(type: ControllingPersonType) {
        this.setState({ selectedType: type });
    }
}
